import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '../services/api';
import photosReducer from './slices/photosSlice';
import meetingsReducer from './slices/meetingsSlice';
import drawingsReducer from './slices/drawingsSlice';
import contractsReducer from './slices/contractsSlice';
import projectReducer from './slices/projectSlice';
import widgetsReducer from './slices/widgetsSlice';

export const store = configureStore({
  reducer: {
    photos: photosReducer,
    meetings: meetingsReducer,
    drawings: drawingsReducer,
    contracts: contractsReducer,
    project: projectReducer,
    widgets: widgetsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for File objects and other non-serializable values
        ignoredActions: ['photos/setUploadFiles', 'photos/updateUploadData'],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.files', 'payload.coordinates'],
        // Ignore these paths in the state
        ignoredPaths: ['photos.uploadData.files'],
      },
    }).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
